import { useQuery } from '@tanstack/react-query'
import { fetchPatients, fetchPatientsByClinicalLocation } from '../services/patient';
import { getActiveRole } from '../utils/permissions';

const GetPatient = (pageNumber = 1, pageSize = 10) => {
  const activeRole = getActiveRole();
  const isClinicalLocationAdmin = activeRole === 'CLINICAL_LOCATION_ADMIN';

  const getPatient = useQuery({
    queryKey: ['patients', pageNumber, pageSize, activeRole],
    queryFn: () =>
      isClinicalLocationAdmin
        ? fetchPatientsByClinicalLocation(pageNumber, pageSize)
        : fetchPatients(pageNumber, pageSize),
  });

  return getPatient;
}

export default GetPatient
